import AppHeader from '@components/AppNavigation/AppHeader';
import AuditsTable from '@components/Audits/AuditsTable';
import React, { FC } from 'react';

const AuditsPage: FC = () => (
	<>
		<AppHeader translation="pages.audits.title" />
		<AuditsTable />
	</>
);

export default AuditsPage;
